import { BrowserRouter as Router } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import { AuthContext } from "./context/AuthContext";
import { ViewportProvider } from "./context/ViewportContext";
import React, { useContext } from "react";
import MainRoutes from "./MainRoutes";
import { ThemeProvider } from "@material-ui/core";
import { createTheme } from "@material-ui/core/styles";
import "./App.css";

import Loading from "./components/iam/Shared/Loading";
import { SocketProvider } from "./context/SocketContext";
const theme = createTheme({
  palette: {
    text: {
      main: "#000000",
    },
    background: {
      main: "#ffff",
    },
    table: {
      head: "#f9fafb",
      border: "1px solid #bfbfbf",
    },
    btn: {
      main: "#1b2132",
    },
  },
});
function App() {
  const { loading } = useContext(AuthContext);
  if (loading)
    return (
      <div>
        <Loading />
      </div>
    );
  return (
    <>
      <ThemeProvider theme={theme}>
        <Router>
          {/* need to wrap contents with SnackbarProvider component for notistack to work */}
          <SnackbarProvider
            anchorOrigin={{
              // show the snackbar at the bottom right of the page
              vertical: "bottom",
              horizontal: "right",
            }}
          >
            <ViewportProvider>
              <SocketProvider>
                <MainRoutes></MainRoutes>
              </SocketProvider>
            </ViewportProvider>
          </SnackbarProvider>
        </Router>
      </ThemeProvider>
    </>
  );
}

export default App;
